import api from "./api";


export async function getAllLanguages() {
    const response = await api.get("/languages");
    return response;

}